import Vue from 'vue'
import axios from "axios";
import qs from 'qs';
import matchDomainName from './matchDomainName';
let hostUrl = '';
let productionUrl=matchDomainName.production();
let testUrl=matchDomainName.test();
axios.defaults.withCredentials = true;
axios.defaults.timeout = 5000;

let reg=/^https/ig
if(process.env.NODE_ENV === 'production'){
//   console.log('productionUrl.flag='+productionUrl.flag)
//   console.log('testUrl.flag='+testUrl.flag)
//   console.log('reg.test(productionUrl.hostname)='+reg.test(productionUrl.hostname))
//   console.log('reg.test(testUrl.hostname)='+reg.test(testUrl.hostname))
  if(productionUrl.flag){
      reg.test(productionUrl.hostname)?(hostUrl = 'https://portal.hxmxfj.com/'):(hostUrl = 'http://portal.hxmxfj.com/')
   }
    if(testUrl.flag){
      reg.test(testUrl.hostname)?(hostUrl = 'https://csportal.hxmxfj.com/'):(hostUrl = 'http://csportal.hxmxfj.com/')
    }
}else{
  // hostUrl ='http://192.168.0.150:8080/';
}
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
  }, function (error) {
    new Vue().$loading.close()
});
axios.defaults.withCredentials = true
export const $axios = options => {
     options.data = qs.stringify(options.data)
     options.url = hostUrl + options.url;
    return axios(options)
}




// WEBPACK FOOTER //
// ./src/assets/js/$axios.js